import { Users, Shield, Eye } from "lucide-react";
import { Label } from "@/modern/components/ui/label";
import { Combobox, TComboSelectedValue } from "@/modern/components/ui/combobox";
import { useChecklistPermissions } from "@/react/hooks/entityHooks/useChecklistPermissions";
import { checkGrantOrder } from "@/modern/utils";

interface PermissionsSectionProps {
  assignedBoardUsers: number[];
  canEdit: number | null | undefined;
  canView: number | null | undefined;
  onAssignedUsersChange: (value: number[]) => void;
  onCanEditChange: (value: TComboSelectedValue | null) => void;
  onCanViewChange: (value: TComboSelectedValue | null) => void;
}

export const PermissionsSection = ({ assignedBoardUsers, canEdit, canView, onAssignedUsersChange, onCanEditChange, onCanViewChange }: PermissionsSectionProps) => {
  const { boardUsers, grants } = useChecklistPermissions();

  // Normalize values for consistent rendering
  const assignedUsersValue = Array.isArray(assignedBoardUsers) ? assignedBoardUsers.map(String) : [];

  return (
    <section className="">
      {/* <div className="flex flex-col gap-1 pb-6">
        <div className="flex items-center gap-2 text-sm">
          <Shield className="size-4" />
          Permissions & Assignment
        </div>
        <p className="text-xs text-muted-foreground">Control who can collaborate on this checklist and who can view the latest updates.</p>
      </div> */}

      <div className="grid gap-6 sm:grid-cols-2">
        <div className="space-y-2 col-span-2">
          <Label className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <Users className="size-3.5" />
            Assigned To
          </Label>
          <Combobox
            value={assignedUsersValue}
            options={boardUsers}
            placeholder="Select users..."
            multiSelect={true}
            showBadges={true}
            enableRemoveButton={true}
            onValueChange={(value) => onAssignedUsersChange(value as number[])}
          />
        </div>

        <div className="space-y-2">
          <Label className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <Shield className="size-3.5" />
            Can Edit
          </Label>
          <Combobox
            buttonSelectedClassName="bg-transparent"
            value={canEdit ?? undefined}
            options={grants}
            placeholder="Select role"
            emptyValue=""
            onValueChange={onCanEditChange}
            onBeforeSelect={({ value }) => {
              return checkGrantOrder({ canEdit: Number(value), canView: Number(canView ?? 0), onViewPermissionError: onCanViewChange });
            }}
          />
        </div>

        <div className="space-y-2">
          <Label className="flex items-center gap-1.5 text-xs font-medium text-muted-foreground">
            <Eye className="size-3.5" />
            Can View
          </Label>
          <Combobox
            value={canView ?? undefined}
            options={grants}
            placeholder="Select role"
            emptyValue=""
            onValueChange={onCanViewChange}
            onBeforeSelect={({ value }) => {
              return checkGrantOrder({ canEdit: Number(canEdit ?? 0), canView: Number(value) });
            }}
          />
        </div>
      </div>
    </section>
  );
};
